import React from 'react';
import { ListCell, ListRow } from '@administrate/piston-ux';
import { withTranslation } from 'react-i18next';
import { observer } from 'mobx-react-lite';
import PropTypes from 'prop-types';
import withCurrency from '../../containers/withCurrency';
import CartItemPrice from '../Cart/CartItemsList/CartItemPrice';

const ChildItems = ({ items, gridColumns, t }) => (
  <>
    <div className="child-items__header">
      <span className="child-items__header__text">
        {t('weblink:additionalItems')}
      </span>
      <hr className="child-items__header__line" />
    </div>

    {items.map(childItem => (
      <ListRow
        key={childItem.id}
        gridColumns={gridColumns}
        dataLabel={childItem.productOption.description}
        className="list__row--child-item"
      >
        <ListCell label={t('name')} className="bold child__description">
          {childItem.productOption.description}
        </ListCell>
        <ListCell label={t('price')}>
          <CartItemPrice amount={childItem.unitAmount} />
        </ListCell>
        <ListCell label={t('quantity')} className="child__quantity">
          x{childItem.quantity}
        </ListCell>
        <ListCell label={t('total')} className="bold">
          <CartItemPrice
            amount={parseFloat(childItem.unitAmount) * childItem.quantity}
          />
        </ListCell>
      </ListRow>
    ))}
  </>
);

ChildItems.propTypes = {
  items: PropTypes.arrayOf(PropTypes.shape({})).isRequired,
  gridColumns: PropTypes.string.isRequired,
  t: PropTypes.func.isRequired,
};

export default withTranslation()(withCurrency(observer(ChildItems)));
